import { render, staticRenderFns } from "./PasswordTips.vue?vue&type=template&id=45549327"
import script from "./PasswordTips.vue?vue&type=script&lang=js"
export * from "./PasswordTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports